import React from "react";
import { CalendarDays } from "lucide-react";
import StatusBadge from "../StatusBadge";

export default function ProposalHeaderCard({ dl, issuerName, locked, logoUrl, quote }) {
  return (
    <div className="bg-card border border-slate-200/80 rounded-2xl shadow-sm p-6 sm:p-8 mb-8">
      <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
        <div>
          <div className="flex items-center gap-3 flex-wrap">
            <span className="font-mono text-sm text-slate-400">{quote.quote_number}</span>
            <StatusBadge status={quote.status} />
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 mt-2">{quote.title}</h1>
        </div>
        {dl !== null && !locked && (
          <div className={`flex items-center gap-2 px-3.5 py-2 rounded-xl border ${dl < 0 ? "bg-red-50 border-red-200 text-red-700" : dl <= 5 ? "bg-amber-50 border-amber-200 text-amber-700" : "bg-slate-50 border-slate-200 text-slate-600"}`}>
            <CalendarDays style={{ width: 16, height: 16 }} />
            <span className="text-sm font-semibold">{dl < 0 ? "Scaduto" : `${dl} giorni alla scadenza`}</span>
          </div>
        )}
      </div>
      {quote.description && <p className="text-slate-600 leading-relaxed mb-6">{quote.description}</p>}
      <div className="grid sm:grid-cols-2 gap-6 pt-6 border-t border-border">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">Da</p>
          {logoUrl && (
            <img data-testid="public-issuer-logo" src={logoUrl} alt={issuerName} className="h-12 max-w-[180px] object-contain mb-2" />
          )}
          <p data-testid="public-issuer-name" className="font-semibold text-slate-900 break-words">{issuerName}</p>
          {quote.issuer.owner_name && quote.issuer.owner_name !== issuerName && <p className="text-sm text-slate-600 break-words">{quote.issuer.owner_name}</p>}
          {quote.issuer.vat_number && <p className="text-sm text-slate-500">P.IVA / C.F. {quote.issuer.vat_number}</p>}
          {quote.issuer.address && <p className="text-sm text-slate-500 break-words">{quote.issuer.address}</p>}
          {quote.issuer.email && <p className="text-sm text-slate-500 break-all">{quote.issuer.email}</p>}
          {quote.issuer.phone && <p className="text-sm text-slate-500">{quote.issuer.phone}</p>}
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">Per</p>
          <p className="font-semibold text-slate-900">{quote.client.name}</p>
          {quote.client.vat && <p className="text-sm text-slate-500">P.IVA/CF {quote.client.vat}</p>}
          {quote.client.address && <p className="text-sm text-slate-500">{quote.client.address}</p>}
          {quote.client.email && <p className="text-sm text-slate-500">{quote.client.email}</p>}
        </div>
      </div>
    </div>
  );
}
